import React, { memo, useCallback, useMemo } from "react"
import { useLocation, useParams } from "react-router-dom"
import DeliveryForm from "../Form/DeliveryForm"
import { IDeliveryFormWrapperProps, IDeliveryForm } from "../../../../Types/MeetingPlanning/deliveryForm"
import { v4 as uuidv4 } from "uuid"
import { ChangeDeliveryData } from "../../Redux/MeetingPlanningActions"
import { useAppNavigation } from "../../../../hooks/useAppNavigation"

const DeliveryFormWrapper = ({ deliveryId, isInitialShow, initialDeliveryForm, meetingPlaningDeliveries, userCanteenId, dispatch }: IDeliveryFormWrapperProps) => {
    const location = useLocation()

    const currentMeetingPlaningDelivery = useMemo(() => meetingPlaningDeliveries.find(delivery => delivery.id === deliveryId) || null, [meetingPlaningDeliveries, deliveryId]);

    const onSubmitDelivery = useCallback((formValues: IDeliveryForm) => {
        const id = deliveryId || uuidv4();

        dispatch(ChangeDeliveryData({
            id,
            isInitial: currentMeetingPlaningDelivery?.isInitial ? currentMeetingPlaningDelivery.isInitial : !meetingPlaningDeliveries?.length,
            order: currentMeetingPlaningDelivery?.order || {},
            formFields: formValues,
        }));

    }, [dispatch, location, userCanteenId, deliveryId])

    return (
        <DeliveryForm
            isInitialShow={isInitialShow}
            initialDeliveryForm={initialDeliveryForm || null}
            currentMeetingPlaningDelivery={currentMeetingPlaningDelivery || null}
            userCanteenId={userCanteenId}
            onSubmit={onSubmitDelivery}
        />
    );
}

export default memo(DeliveryFormWrapper)
